'use strict';
var novicell = novicell || {};

novicell.timePickers = novicell.timePickers || function () {

    function init() {
        timePickers();
    }

    function timePickers() {
        let controls = document.querySelectorAll(".time-picker");
        if (controls.length > 0) {
            jQuery(".time-picker").timepicker({
                timeFormat: 'H:i',
                dynamic: true,
                dropdown: true,
                scrollbar: true
            })
        }
    }

    return {
        init: init,
        timePickers: timePickers
    };

}();
